<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Post NL verhuisservice</h1>
      <p>
        Als u gaat verhuizen, dan doet u er verstandig om gebruik te maken van
        de Post NL verhuisservice (tegenwoordig de PostNL verhuisservice). Als u
        deze service heeft aangevraagd, worden alle belangrijke instanties en
        bedrijven ingelicht over uw adreswijziging. Deze organisaties kunt u
        zelf selecteren. De Post NL verhuisservice zorgt er vervolgens
        desgewenst voor dat de post die daarna geadresseerd is aan uw oude
        adres, wordt doorgestuurd naar uw nieuwe adres. U bepaalt zelf hoe lang
        dit gebeurt. Zelfs als u in het voortaan in het buitenland woont, kunt u
        van deze mogelijkheid gebruik maken.
      </p>

      <h2>Kosten en voorwaarden</h2>
      <p>
        De Post NL verhuisservice is in de eerste maand gratis, mits u binnen
        Nederland verhuist. Daarna is de hoogte van het bedrag dat u moet
        betalen afhankelijk van het aantal maanden dat u gebruik maakt van de
        service. Buiten Nederland liggen de tarieven hoger, maar binnen Europa
        bent u wel voordeliger uit dan daarbuiten. Met de Post NL verhuisservice
        wordt in principe alle post doorgestuurd, al zijn er een paar
        voorwaarden: zo moet uw naam op de post staan, moet de post door de
        brievenbus passen, uit Nederland afkomstig zijn en door PostNL bezorgd
        worden. Wilt u graag precies weten wat de Post NL verhuisservice kost en
        welke uitzonderingen er worden gemaakt? Dan kunt u terecht op de website
        van PostNL.
      </p>

      <h2>Post NL verhuisservice en offertes: nooit te vroeg!</h2>
      <p>
        Ook wanneer uw verhuizing pas over een aantal maanden gepland staat, is
        het niet te vroeg om te beginnen met de voorbereidingen. Begin dus vast
        met het regelen van zaken, zoals het aanvragen van de Post NL
        verhuisservice, maar bijvoorbeeld eveneens met het inpakken van dozen.
        Ook met het vergelijken van offertes kunt u het beste ruim van tevoren
        beginnen, zodat u op tijd weet met welke verhuizers u in zee gaat.
        Voorkom een hoop geregel op het laatste moment en vraag vandaag nog
        gratis offertes aan van
        <nuxt-link to="/"> verhuisbedrijven </nuxt-link> in uw eigen regio!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Post NL verhuisservice: maak het uzelf niet moeilijker dan nodig is!',
      headDescription:
        'Ga je verhuizen? Vergelijk gratis offertes op Alleverhuizers.nl en lees de tips op de website! Lees bijvoorbeeld alles over de Post NL verhuisservice.',
    }
  },
}
</script>
